import { AuthService } from "./AuthService";
import { AuthConfiguration } from "./authConfiguration";

export class AuthHelper {

  private static accessTokenKey: string = "accessToken";
  private static authConfigKey: string = "authConfig";

  static async init (authConfig: AuthConfiguration): Promise<void> {
    sessionStorage.setItem(this.authConfigKey, JSON.stringify(authConfig));
    const _authService = new AuthService(authConfig, authConfig.apiScopes);
    await _authService.init();
  }

  static getAuthConfig (): AuthConfiguration | undefined {
    const authConfigStr = sessionStorage.getItem(this.authConfigKey);
    if (!authConfigStr)
      return undefined;

    const authConfig: AuthConfiguration = JSON.parse(authConfigStr.toString());
    return authConfig;
  }

  static saveAccessToken (token: string): void {
    sessionStorage.setItem(this.accessTokenKey, token);
  }

  static getAccessToken (): string | null {
    return sessionStorage.getItem(this.accessTokenKey);
  }

  static removeAccessToken (): void {
    sessionStorage.getItem(this.accessTokenKey);
  }

  static getAuthService (): AuthService | null {
    const authConfig: (AuthConfiguration | undefined) = AuthHelper.getAuthConfig();
    if (!authConfig) {
      return null;
    }
    return new AuthService(authConfig, authConfig.apiScopes);
  }
}